import { success, warning, critical, buttonSuccess, buttonWarning, buttonCritical } from '../../tokens';
import { collectPackageInfo } from '../../collectPackageInfo';
collectPackageInfo('Field/Field.statuses');
export var fieldStatuses = {
  success: success,
  warning: warning,
  error: critical
};
export var fieldBackgroundStatuses = {
  success: buttonSuccess,
  warning: buttonWarning,
  error: buttonCritical
};